export const TUTORIAL_STEPS = [
  {
    id: 'goals',
    title: "Today's Goals",
    description:
      'Track your daily progress and unlock achievements by completing these tasks! Clicking on a task will take you to the corresponding page.',
    placement: 'left',
    image: '/maincar.png',
  },
  {
    id: 'achievements',
    title: 'Achievements',
    description:
      'Earn badges by completing tasks and reaching milestones in your internship journey!',
    placement: 'right',
    image: '/thinkingcar.png',
  },
  {
    id: 'calendar',
    title: 'Progress',
    description: 'Keep track of your daily engagement and build a consistent learning habit.',
    placement: 'right',
    image: '/maincar.png',
  },
  {
    id: 'events',
    title: 'Your Status',
    description: 'Keep yourself accountable by seeing your progress!',
    placement: 'left',
    image: '/thinkingcar.png',
  },
];
